<div class="choose-capability mb-24">
  <div class="pt-26 pl-72 pr-72 header-section">
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div class="flex flex-row flex-auto mt--8 pr-24 pb-24 create-service">
      <div class="flex flex-row items-start mt-8">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0 mr-24"
          [routerLink]="['/', authService.principal.provider, RouterSegments.TENANT, tenantId, RouterSegments.BLUEPRINTS, RouterSegments.SOLUTION]"></mat-icon>
      </div>
      <div class="flex flex-col">
        <div class="mat-subtitle-1 fw-600 mb-0">{{'CREATE_SERVICE.CREATE_SERVICE_DEFINITION' | transloco}}</div>
        <div *ngIf="!isLoading; else solutionNameLoader" class="flex flex-row mt-4">
          <span class="fw-600 mr-4">{{'INSTANCE_DETAILS.SOLUTION' | transloco}}:</span>
          <span>{{ solution?.name }}</span>
        <div class="flex flex-row justify-center items-center vertical-indicator ml-6 h-18 mt-4">
          <span class="mr-10 ml-6">
            <span class="fw-600">{{'BLUEPRINT_SUMMARY.RELEASE' | transloco}}</span>:
            {{(latestSolutionVersion?.releaseVersion ? latestSolutionVersion?.releaseVersion : ('CREATE_SERVICE.NO_RELEASE' | transloco))}}
          </span>
        </div>
        </div>
      </div>
      <ng-template #solutionNameLoader>
        <div class="skeleton-loader mt-8">
          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      </ng-template>
    </div>
    
    
    <div *ngIf="capabilitiesPage" class="flex flex-row mt-24 mb-40">
      <form [formGroup]="solutionVersionForm" class="flex flex-row">
        <div class="flex-col name-width">
          <div class="flex mb-8 items-center fw-700 fs-12">{{ 'INSTANCE_DETAILS.SOLUTION_NAME' | transloco | uppercase}}
            <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.SOLUTION_NAME' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <div class="flex">
            <label class="fw-500 fs-16 pl-12 value-color flex items-center mr-24" (click)="navigateToSolution(solution?.id)"><span class="pl-12 pr-12 solutionId-color">{{ solution?.name }}</span></label>
          </div>
        </div>
        <div class="flex flex-col mat-subtitle-2 fw-700 fs-12 mb-24 version-width">
          <div class="flex mb-8 items-center fw-700 fs-12">{{ 'INSTANCE_DETAILS.SOLUTION_VERSION' | transloco | uppercase}}
            <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.SOLUTION_VERSION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <div>
            <mat-select class="fw-500 form-select version-selections" [value]="selectedBuildVersion" [formControl]="solutionVersionForm.get('buildVersion')" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" panelClass="version-selections" (click)="resetFilter()" (selectionChange)="getSelectedVersion($event.value)" (closed)="dropdownClose()">
              <div class="flex search-bar m-8">
                <span (click)="searchChanged(searchValue)" class="pt-4 w-26"><mat-icon class="mr-8 icon-sm icon-color ml-6 mt-4 mr-10" svgIcon="search"></mat-icon></span>
                <input [formControl]="solutionVersionForm.get('searchValue')" (ngModelChange)="onOptionsSelected(solutionVersionForm.get('searchValue'))" class="fw-400 h-30 fs-14" placeholder="Search" type="text">                      
              </div>
              <div class="ml-16 mr-16 mt-8 mb-8 flex justify-center" *ngIf="versionData?.length === 0 || !isVersionAvailable">{{'INSTANCE_DETAILS.UPDATE_BUILD.NO_VERSIONS_FOUND' | transloco}}</div>
              <mat-option *ngFor="let version of versionData" [value]="version" [title]="version?.releaseVersion" [ngClass]="{'group-title': version.group, 'group-items': !version.group, 'no-release-version': !isVersionAvailable}">{{version?.releaseVersion}}</mat-option>
            </mat-select>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="showLoader">
    <mat-card class="flex spinner-container load-spinner mt-100">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
    <div class="flex justify-center loading-capabilities mt-100">{{'INSTANCE_DETAILS.LOADING_CAPABILITIES' | transloco}}</div>
  </div>
  <ng-container *ngIf="versionSelected; else chooseVersion">
    <div *ngIf="capabilitiesPage && !showLoader" class="pl-72 pr-72 pt-24 flex flex-col">
      <div class="capabilities-section">
        <div *ngIf="includedCapabilities?.length > 0 || optionalCapabilities?.length === 0">
          <div class="mat-subtitle-1 fw-700 fs-24 mb-20">{{'CREATE_SERVICE.INCLUDED_CAPABILITIES' | transloco}}<span class="ml-4">({{ includedCapabilities?.length }})</span></div>
          <div *ngIf="!isLoading; else loader" class="flex flex-row">
            <div class="p-24 mr-24 fw-600 fs-24 capability" *ngFor="let capability of includedCapabilities">
              <div class="height-additional">{{ capability?.displayName ? (capability?.displayName | titlecase) : (capability?.name | titlecase) }}</div>
              <a *ngIf="capability.hasNested && (!capability?.selectedNestedObj || capability?.selectedNestedObj?.length === 0)" class="items-center position-link fw-400 fs-14" (click)="onClick(capability)" href="javascript:void(0)">{{'CREATE_SERVICE.ADD_ADDITIONAL_CAPABILITIES' | transloco}}</a>
              <div *ngIf="capability.hasNested && capability?.selectedNestedObj?.length > 0" class="flex flex-row position-link justify-between">
                <div class="flex flex-col">
                  <div class="fw-600 fs-16">{{'CREATE_SERVICE.ADDITIONAL_CAPABILITIES' | transloco}}{{':'}}</div>
                  <div class="additional-capability">
                    <span *ngFor="let nestedCapability of capability?.selectedNestedObj; let i = index">
                      <span class="mat-body-1">{{nestedCapability?.displayName ? nestedCapability?.displayName : nestedCapability?.name}}</span>
                      <span *ngIf="i !== (capability?.selectedNestedObj?.length - 1)" class="mr-4">,</span>
                    </span>
                  </div>
                </div>
                <div class="flex justify-end cursor-pointer" (click)="onClick(capability)">
                  <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <mat-divider *ngIf="includedCapabilities?.length > 0 && optionalCapabilities?.length > 0" class="neutral-2 mt-34 mb-24"></mat-divider>
        <div *ngIf="optionalCapabilities?.length > 0">
          <div class="mat-subtitle-1 fw-700 fs-24 mb-20">{{'CREATE_SERVICE.OPTIONAL_CAPABILITIES' | transloco}}<span class="ml-4">({{ optionalCapabilities?.length }})</span></div>
          <div *ngIf="!isLoading; else loader" class="flex flex-row flex-wrap gap-6">
            <div class="flex p-24 capability" [ngClass]="{ 'unselected': !capability?.selected}" *ngFor="let capability of optionalCapabilities">
              <div class="flex flex-row w-100-percent justify-between height-additional">
                <span class="fw-600 fs-24">{{ capability?.displayName ? (capability?.displayName | titlecase) : (capability?.name | titlecase) }}</span>
                <mat-icon [svgIcon]="capability?.selected ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-12" (click)="selectCapability(capability)"></mat-icon>
              </div>
              <a *ngIf="capability.hasNested && (!capability?.selectedNestedObj || capability?.selectedNestedObj?.length === 0)" class="items-center position-link fw-400 fs-14" [ngClass]="{ 'disabled': !capability.showAdditional}" (click)="onClick(capability)" href="javascript:void(0)">{{'CREATE_SERVICE.ADD_ADDITIONAL_CAPABILITIES' | transloco}}</a>
              <div *ngIf="capability.hasNested && capability?.selectedNestedObj?.length > 0" class="flex flex-row position-link justify-between">
                <div class="flex flex-col">
                  <div class="fw-600 fs-16">{{'CREATE_SERVICE.ADDITIONAL_CAPABILITIES' | transloco}}{{':'}}</div>
                  <div class="additional-capability">
                    <span *ngFor="let nestedCapability of capability?.selectedNestedObj; let i = index">
                      <span class="mat-body-1">{{nestedCapability?.displayName ? nestedCapability?.displayName : nestedCapability?.name}}</span>
                      <span *ngIf="i !== (capability?.selectedNestedObj?.length - 1)" class="mr-4">,</span>
                    </span>
                  </div>
                </div>
                <div class="flex justify-end cursor-pointer" (click)="onClick(capability)">
                  <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #loader>
          <div class="flex">
            <div class="skeleton-loader mr-24 mt-8" *ngFor="let item of [1,2,3]">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-template #chooseVersion>
    <div *ngIf="capabilitiesPage" class="pl-72 pr-72 pt-24 flex flex-col">
      <div class="capabilities-section">
        <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
          <img src="/assets/images/choose_solution_version.png"> 
          <div class="mt-10 choose-solution-version">{{'INSTANCE_DETAILS.CHOOSE_SOLUTION_VERSION' | transloco}}</div>
        </div>
      </div>
    </div>
  </ng-template>
  <div *ngIf="!capabilitiesPage" class="pl-72 pr-72 pt-24 flex flex-col">
    <div *ngIf="exchangeAdapters?.length > 0" class="capabilities-section">
      <div class="mat-subtitle-1 fw-700 fs-24 mb-20">{{'CREATE_SERVICE.EXCHANGE_ADAPTERS' | transloco}}<span class="ml-4">({{ exchangeAdapters?.length }})</span></div>
      <div class="flex flex-row flex-wrap gap-6">
        <div class="flex p-24 capability" [ngClass]="{ 'unselected': !capability?.selected}" *ngFor="let capability of exchangeAdapters">
          <div class="flex flex-row w-100-percent justify-between height-additional">
            <span class="fw-600 fs-24">{{ capability?.displayName ? (capability?.displayName | titlecase) : (capability?.name | titlecase) }}</span>
            <mat-icon [svgIcon]="capability?.selected ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-12" (click)="selectExchangeAdapter(capability)"></mat-icon>
          </div>
          <a *ngIf="capability.hasNested && (!capability?.selectedNestedObj || capability?.selectedNestedObj?.length === 0)" class="items-center position-link fw-400 fs-14" [ngClass]="{ 'disabled': !capability.showAdditional}" (click)="onClick(capability)" href="javascript:void(0)">{{'CREATE_SERVICE.ADD_ADDITIONAL_CAPABILITIES' | transloco}}</a>
          <div *ngIf="capability.hasNested && capability?.selectedNestedObj?.length > 0" class="flex flex-row position-link justify-between">
            <div class="flex flex-col">
              <div class="fw-600 fs-16">{{'CREATE_SERVICE.ADDITIONAL_CAPABILITIES' | transloco}}{{':'}}</div>
              <div class="additional-capability">
                <span *ngFor="let nestedCapability of capability?.selectedNestedObj; let i = index">
                  <span class="mat-body-1">{{nestedCapability?.displayName ? nestedCapability?.displayName : nestedCapability?.name}}</span>
                  <span *ngIf="i !== (capability?.selectedNestedObj?.length - 1)" class="mr-4">,</span>
                </span>
              </div>
            </div>
            <div class="flex justify-end cursor-pointer" (click)="onClick(capability)">
              <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="exchangeAdapters?.length === 0">
      <div class="mat-subtitle-1 fw-700 fs-24 mb-20">{{'CREATE_SERVICE.EXCHANGE_ADAPTERS' | transloco}}</div>
      <div class="no-data flex flex-col items-center justify-center mat-body-1 pt-8 pb-8 fw-500 fs-16 mt-70">
        <img src="/assets/images/instance-not-found-small.png"> 
        <div class="mt-16">{{'CREATE_SERVICE.EXCHANGE_ADAPTERS_NO_DATA' | transloco }}</div>
      </div>
    </div>
  </div>
</div>


<span class="flex-auto"></span>
<div *ngIf="capabilitiesPage && !showLoader && versionSelected" class="summary-header pale max-width-lg mt-auto">
  <div class="flex flex-row justify-between max-width">
    <div class="flex flex-row">
      <div class="flex flex-row">
        <img  class="bubble" src="/assets/images/bubble.png">
        <span class="flex justify-items-center count fw-600 mr-6 pl-8 p-4 mat-body-1 m-0">{{includedCapabilities?.length > 0 ? (includedCapabilities?.length + additionalIncluded?.length) : 0}}</span>
        <span class="mat-subtitle-2 fw-500 pt-4 pl-6 mr-24">{{'CREATE_SERVICE.INCLUDED' | transloco}}</span>
      </div>
      <div class="flex flex-row">
        <img  class="bubble" src="/assets/images/bubble.png">
        <span class="flex justify-items-center count fw-600 mr-6 pl-8 p-4 mat-body-1 m-0">{{selectedCapability?.length > 0 ? (selectedCapability?.length + additionalOptional?.length) : 0}}</span>
        <span class="mat-subtitle-2 fw-500 pt-4 pl-6">{{'CREATE_SERVICE.OPTIONAL' | transloco}}</span>
        <mat-icon (click)="resetSelection()" svgIcon="refresh" class="icon-md cursor-pointer mt-4 ml-8 ml-16"></mat-icon>
      </div>
    </div>
    <div class="flex flex-row">
      <div class="flex justify-items-center items-center ml-auto cursor-pointer mr-50" (click)="previous()">
        <mat-icon class="icon-sm mr-8" svgIcon="arrow_back"></mat-icon>
        <span class="mat-subtitle-2 fw-700 cursor-pointer">{{ 'BUTTONS.PREVIOUS' | transloco }}</span>
      </div>
      <button (click)="goBack()" class="flex justify-items-center items-center cancel-btn ml-auto mr-26 pr-16 pl-16 pt-8 pb-8">
        {{ 'BUTTONS.CANCEL' | transloco }}
      </button>
      <button (click)="continue()" [ngClass]="{ 'disabled': includedCapabilities?.length === 0 && selectedCapability?.length === 0}"
              class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8"
              type="button">
              {{'BUTTONS.NEXT' | transloco}}
      </button>
    </div>
  </div>
</div>

<div *ngIf="!capabilitiesPage" class="summary-header pale max-width-lg mt-auto">
  <div class="flex flex-row justify-between max-width">
    <div class="flex flex-row">
      <div class="flex flex-row">
        <img  class="bubble" src="/assets/images/bubble.png">
        <span class="flex justify-items-center count fw-600 mr-6 pl-8 p-4 mat-body-1 m-0">{{selectedExchangeAdapters?.length > 0 ? (selectedExchangeAdapters?.length + additionalExchangeAdapters?.length) : 0}}</span>
        <span class="mat-subtitle-2 fw-500 pt-4 pl-6">{{'CREATE_SERVICE.SELECTED' | transloco}}</span>
        <mat-icon (click)="resetExchangeSelection()" svgIcon="refresh" class="icon-md cursor-pointer mt-4 ml-8 ml-16"></mat-icon>
      </div>
    </div>
    <div class="flex flex-row">
      <div class="flex justify-items-center items-center ml-auto cursor-pointer mr-50" (click)="previousCapabilityPage()">
        <mat-icon class="icon-sm mr-8" svgIcon="arrow_back"></mat-icon>
        <span class="mat-subtitle-2 fw-700 cursor-pointer">{{ 'BUTTONS.PREVIOUS' | transloco }}</span>
      </div>
      <button (click)="goBack()" class="flex justify-items-center items-center cancel-btn ml-auto mr-26 pr-16 pl-16 pt-8 pb-8">
        {{ 'BUTTONS.CANCEL' | transloco }}
      </button>
      <button (click)="createService()" [disabled]="includedCapabilities?.length === 0 && selectedCapability?.length === 0"
              class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8"
              type="button">
              {{'BUTTONS.NEXT' | transloco}}
      </button>
    </div>
  </div>
</div>
